import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetApiStatisticsQuery } from '../api/apiStatistics';
import { ApiStatisticsFilters } from '../api/apiStatistics';
import { ApiStatisticsFiltersComponent } from '../components/ApiStatisticsFilters';
import { ApiStatisticsDashboard } from '../components/ApiStatisticsDashboard';
import ProtectedRoute from '../components/ProtectedRoute';

const ApiStatisticsPage: React.FC = () => {
  const { t } = useTranslation('apiStatistics');
  const [filters, setFilters] = useState<ApiStatisticsFilters>({});

  const { data, isLoading, error } = useGetApiStatisticsQuery(filters);

  const handleFiltersChange = (newFilters: ApiStatisticsFilters) => {
    setFilters(newFilters);
  };



  if (isLoading) {
    return (
      <ProtectedRoute requiredRoles={['admin']}>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600 dark:text-gray-400">{t('loading')}</p>
          </div>
        </div>
      </ProtectedRoute>
    );
  }

  if (error) {
    return (
      <ProtectedRoute requiredRoles={['admin']}>
        <div className="space-y-6">
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">
                  {t('error_loading_data')}
                </h3>
                <div className="mt-2 text-sm text-red-700">
                  <p>{t('error_message')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ProtectedRoute>
    );
  }

  return (
    <ProtectedRoute requiredRoles={['admin']}>
      <div className="space-y-6">
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">{t('title')}</h2>
          
          <div className="mb-6">
            <ApiStatisticsFiltersComponent
              filters={filters}
              onFiltersChange={handleFiltersChange}
            />
          </div>

          {data && (
            <ApiStatisticsDashboard
              data={data}
            />
          )}
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default ApiStatisticsPage; 